/* istanbul ignore file */
import React from 'react';
import { CreateButtonProps, CreateButton } from 'framework/ui/ui-builder';
import { CREATE_CONTACT } from 'domain/sales/contact/shared/contactService';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const CreateContactButton = (props: Partial<CreateButtonProps>) => {
  const { getCreateUrl } = useContactUrl();

  return <CreateButton {...props} url={getCreateUrl()} permissionToCheck={CREATE_CONTACT} label="Create contact" />;
};

export default CreateContactButton;
